import { useTranslation } from 'react-i18next';

import { absoluteUrl, copyText } from '@/shared/lib/internal-links';
import { useToast } from '@/shared/ui';

/**
 * "Copy link" of a resource: puts the absolute address of its canonical page on the clipboard and
 * says so (or says it failed). The address holds the resource's id only - no name, no secret.
 */
export function useCopyLink(): (path: string) => void {
  const { t } = useTranslation();
  const toast = useToast();
  return (path) => {
    void copyText(absoluteUrl(path)).then((ok) => {
      toast.show({ message: ok ? t('links.copied') : t('links.copyFailed') });
    });
  };
}
